import React, { useContext, useEffect } from 'react'
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { TemplatePage } from '../../../components/TemplatePage'
import { globalStyle } from '../../../theme/global'
import { DropdownComponent } from '../../../components/DropdownComponent'
import { Separator } from '../../../components/Separator'
import { toqueColor } from '../../../theme/colors'
import { NavigationProp, useNavigation } from '@react-navigation/native'
import { LogisticsRoutes } from '../../../navigator/types'
import { DOBRA } from '../../../theme/fonts'
import { useTranslation } from 'react-i18next'
import { FuelContext } from '../../../context/Logistics/fuel/FuelProvider'
import { useForm } from '../../../hooks/useForm'
import { Button } from '../../../components/Button'
import moment from 'moment'
import { GetLogisticInitialParameters } from '../../AreaSelector/hooks/useAreaSelector'
import { useContextApp } from '../../../hooks/useContextApp'
import { AuthContext } from '../../../context/Auth/AuthContext'

interface Values {
  orderId: number
  supplierId: number
  supplierName: string
  shipId: number
  shipName: string
}
export const FuelReceptions = () => {
  const {
    params,
    handleOrderByType,
    handleValueNumber,
    handleSaveRecord,
    getRecordById,
    setRecordByOrderNumber,
  } = useContext(FuelContext)
  const { user } = useContext(AuthContext)
  const { fuelContext } = useContextApp()
  const navigation = useNavigation<NavigationProp<LogisticsRoutes, 'FuelReception'>>()
  const { t } = useTranslation()
  const { values, onChangeValues } = useForm<Values>({
    shipId: 0,
    shipName: '',
    supplierId: 0,
    supplierName: '',
    orderId: 0,
  })

  const refreshInitialData = GetLogisticInitialParameters({
    onSuccess: (data) => {
      fuelContext.handleInitialData(data)
    },
  })

  useEffect(() => {
    refreshInitialData.handleSendData({ ['id_user']: user.userId! })
  }, [])

  const handleNext = () => {
    const order = params.plannedOrders.find((order) => order.id === values.orderId)
    const orderNumber = order?.number ?? ''

    const existingRecord = getRecordById(orderNumber)
    if (existingRecord?.stateForm === 'in-progress') {
      setRecordByOrderNumber(orderNumber)
      navigation.navigate('InitialPhotoRod')
      return
    }

    const center = getCenterByArtifact(order?.navalArtifactId ?? 0)
    const artifact =
      center &&
      params.navalArtifact[center.id]?.find((artifact) => artifact.id === order?.navalArtifactId)

    const statusTime = order?.statusDetail[0]?.timestamp ?? moment().format('YYYY-MM-DDTHH:mm:ss')
    const orderId = order?.id ?? 0
    const centerId = center ? center.id : 0
    const centerName = center?.name ?? ''
    const deliveryDate = order?.orderDate ?? ''
    const pontoonId = artifact?.id ?? 0
    const pontoonName = artifact?.name ?? ''

    handleOrderByType(
      {
        ...values,
        centerId,
        centerName,
        deliveryDate,
        pontoonId,
        pontoonName,
        orderNumber,
        orderStateId: order?.statusId ?? 0,
        orderId,
        shipId: values.shipId,
        shipName: values.shipName,
        supplierId: values.supplierId,
        supplierName: values.supplierName,
        statusTime,
      },
      'automatic',
    )

    handleValueNumber({ type: 'meterNumber', value: order?.nominalValue ?? 0 })

    handleSaveRecord({
      orderId,
      orderNumber,
      deliveryDate,
      centerId,
      centerName,
      supplierId: values.supplierId,
      supplierName: values.supplierName,
      shipId: values.shipId,
      shipName: values.shipName,
      statusDetail: { Creado: { status: 'Creado', time: statusTime } },
      pontoonId,
      pontoonName,
      numberOfLiters: null,
      testResult: null,
      meterNumber: order?.nominalValue ?? 0,
      voucherNumber: null,
      photos: null,
      stateForm: 'in-progress',
      savedAt: null,
    })

    navigation.navigate('InitialPhotoRod')
  }

  const getCenterByArtifact = (artifactId: number) =>
    params.centers.find((center) =>
      center.naval_artifacts.find((artifact) => artifact.id === artifactId),
    )
  return (
    <TemplatePage
      styleContent={{ padding: 0, marginBottom: 0 }}
      header
      title={t('Recepción combustible')}
    >
      <View style={[globalStyle.viewContainer, { padding: 20 }]}>
        <DropdownComponent
          label={t('N° pedido')}
          data={params.plannedOrders.map((item) => ({ id: item.id, name: item.label }))}
          onChange={(_, item) => {
            onChangeValues({ name: 'orderId', value: item!.id })
          }}
          placeholder={
            refreshInitialData.isLoading ? t('Actualizando ordenes disponibles') : t('Seleccione')
          }
          hasIcon
          containerStyles={{ marginBottom: 16 }}
          disabled={refreshInitialData.isLoading}
        />

        <DropdownComponent
          label={t('Proveedor')}
          data={params.suppliers}
          onChange={(_, item) => {
            onChangeValues({ name: 'supplierId', value: item!.id })
            onChangeValues({ name: 'supplierName', value: item!.name })
          }}
          placeholder={t('Seleccione')}
          hasIcon
          containerStyles={{ marginBottom: 16 }}
        />

        <DropdownComponent
          label={t('Embarcación')}
          data={params.ship[values.supplierId] ?? []}
          onChange={(_, item) => {
            onChangeValues({ name: 'shipId', value: item!.id })
            onChangeValues({ name: 'shipName', value: item!.name })
          }}
          placeholder={t('Seleccione')}
          hasIcon
          containerStyles={{ marginBottom: 16 }}
        />

        <Separator customStyle={{ borderBottomWidth: 1, marginBottom: 16 }} />

        <TouchableOpacity onPress={() => navigation.navigate('ManualOrder')}>
          <Text style={styles.manualEntry}>+ {t('Ingresar pedido manual')}</Text>
        </TouchableOpacity>
      </View>
      <View style={styles.containerBtn}>
        <Button
          label={t('Iniciar prueba de agua')}
          onPress={handleNext}
          customStyle={{ width: 200, padding: 8, paddingVertical: 12 }}
          disabled={Object.values(values).some((val) => val === 0 || val === '')}
        />
      </View>
    </TemplatePage>
  )
}

const styles = StyleSheet.create({
  manualEntry: {
    fontWeight: '500',
    fontSize: 18,
    color: toqueColor,
    lineHeight: 22,
    fontFamily: DOBRA,
  },

  containerBtn: {
    alignItems: 'center',
    position: 'absolute',
    bottom: 20,
    width: '100%',
  },
})
